import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
// fallow-ignore-next-line boundary-violation -- route params are built with the shared router helper
import { StateParamsConfig } from "single-spa/react-app/router/utils/state-params-build/params-config";

import type { AiChannelsParamKeys, AiChannelsParamsDefinition } from "./routes.types";

const aiChannelsParamsDefinition: AiChannelsParamsDefinition = {
    key: {
        type: "string",
        dynamic: false,
    },
    duration: {
        type: "string",
        value: "28d",
    },
    webSource: {
        type: "string",
        value: devicesTypes.DESKTOP,
    },
    country: {
        type: "int",
        array: false,
        value: 840,
    },
    isWWW: {
        type: "string",
        value: "*",
    },
    sort: {
        type: "string",
        value: "Recent",
    },
    dataFilters: {
        type: "json",
        array: false,
        dynamic: true,
    },
    adsViewType: {
        type: "int",
        array: false,
        value: 0,
    },
    // Open tab of the asset picker dropdown.
    tab: {
        type: "string",
        array: false,
        dynamic: true,
    },
    // Domain whose gallery is on screen in compare mode; defaults to the first selected domain.
    adsSelectedSite: {
        type: "string",
        array: false,
        dynamic: false,
    },
} as const;

export const aiChannelsParams = new StateParamsConfig<AiChannelsParamsDefinition, AiChannelsParamKeys>(
    aiChannelsParamsDefinition,
);

/** swSettings component gating the AI ads gallery: Open for touch users, Hook for no-touch. */
export const AI_ADS_CLAIM = "AdIntAIAds";

const ROOT_STATE_NAME = "ai-channels";

export const ROUTES: Record<"ABSTRACT" | "ADS", { stateName: string; url: string }> = {
    ABSTRACT: {
        stateName: ROOT_STATE_NAME,
        url: "/ai-channels",
    },
    ADS: {
        stateName: `${ROOT_STATE_NAME}.ads`,
        url: "/ads",
    },
} as const;

const LEGACY_ROOT_STATE_NAME = "llms-channels";

// Pre-rename states, kept so existing links and bookmarks land on their `ai-channels` twin
// instead of a 404.
export const LEGACY_ROUTES: Record<"ABSTRACT" | "PROMO", { stateName: string; url: string }> = {
    ABSTRACT: {
        stateName: LEGACY_ROOT_STATE_NAME,
        url: "/llms-channels",
    },
    PROMO: {
        stateName: `${LEGACY_ROOT_STATE_NAME}.promo`,
        url: "/promo",
    },
} as const;
